import React from 'react'

import AddBuyerForm from '../../modules/Buyer/components/AddBuyerForm'
export default function AddBuyerPage() {
  return (
    <AddBuyerForm/>  )
}
